import React from 'react';
import Barcode from 'react-barcode';
import { trim } from 'lodash';

const BonusProductBarcode = (props) => {
  const { bonusProduct, count = 1 } = props;

  return (
    <div className="bonus__product__barcode">
      {trim(bonusProduct.barcode) !== '' && (
        <Barcode
          height={100}
          fontSize={16}
          value={bonusProduct.barcode}
          width={3}
        />
      )}

      {trim(bonusProduct.barcode) === '' && <div>無設定 barcode</div>}

      <div>
        [ {bonusProduct.name} ]{count > 1 && <span> x {count}</span>}
      </div>
    </div>
  );
};

export default BonusProductBarcode;
